export const dispatchUtilFn = (
    dispatchSetCanRequestVideo: { (): { payload: boolean; type: string }; (): void },
    dispatchSetLiveUnitId: { (): { payload: number | null; type: string }; (): void },
) => {
    dispatchSetCanRequestVideo();
    dispatchSetLiveUnitId();
};
